import * as React from 'react'
import { Button } from '@mobiscroll/react-latest'
import UIMessages from 'src/utils/ui-messages'

interface ITeamMemberBottomPanelProps {
  completed?: boolean
  fetching?: boolean
  processing?: boolean
  onCancelClick: () => void
  onSubmitClick: () => void
}

const TeamMemberBottomPanel = ({
  completed = false,
  fetching = false,
  processing = false,
  onCancelClick,
  onSubmitClick
}: ITeamMemberBottomPanelProps) => {
  const { cancel, save } = UIMessages.common

  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='flex justify-end pr3 w100'>
        <Button
          ariaLabel='Cancel button'
          className='mbsc-flat-white-btn'
          disabled={fetching || processing}
          onClick={onCancelClick}
        >
          {cancel}
        </Button>
        <Button
          ariaLabel='Save button'
          className='mbsc-success-btn'
          disabled={fetching || processing}
          onClick={onSubmitClick}
        >
          {save}
        </Button>
      </div>
    </div>
  )
}

export default TeamMemberBottomPanel



// WEBPACK FOOTER //
// ./src/components/team-members/form/TeamMemberBottomPanel.tsx